<template>
  <transition @appear="appear" appear>
    <div
      v-hover-scale-mouse
      data-apollo-hover
      @mouseenter="animateStroke"
      @click="resetRoute">
      <icon-logo class="logo"/>
    </div>
  </transition>
</template>

<script>
import { mapMutations } from 'vuex';
import anime from 'animejs';
import IconLogo from '@/assets/svg/logo.svg';

export default {
  name: 'Logo',
  data() {
    return {
      inTransition: false,
    };
  },
  components: {
    IconLogo,
  },
  methods: {
    ...mapMutations([
      'closeMenu',
      'goAtPage',
    ]),
    resetRoute() {
      if (this.$route.name !== 'Home') this.$router.push('/');
      this.goAtPage('Imagine');
      this.closeMenu();
    },
    appear(ele, done) {
      if (!this.inTransition) {
        this.inTransition = true;
        anime({
          targets: ele.querySelectorAll('.path'),
          strokeDashoffset: [anime.setDashoffset, 0],
          easing: 'easeInOutSine',
          duration: 1500,
          complete: () => {
            this.inTransition = false;
            done();
          },
        });
      }
    },
    animateStroke({ target }) {
      if (!this.inTransition) {
        this.inTransition = true;
        anime({
          targets: target.querySelectorAll('.path'),
          strokeDashoffset: [0, anime.setDashoffset],
          easing: 'easeInOutSine',
          duration: 1500,
          loop: 2,
          direction: 'alternate',
          complete: () => {
            this.inTransition = false;
          },
        });
      }
    },
  },
};
</script>

<style scoped>
.logo {
  width: 7.5vw;
  min-width: 70px;

  cursor: pointer;

  transform: translateY(-50%);
}
</style>
